import React, { memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { CONTACTS } from 'constants/Entities';
import EntityMenu from 'containers/components/EntityMenu';
import { canManageMarketingCampaigns } from 'containers/campaigns/marketing/utils/marketingCampaignPermissions';
import useMarketingBulkSubscribeExtraActions from 'containers/campaigns/marketing/bulkSubscribe/useMarketingBulkSubscribeExtraActions';
import { getIncludedSelectionIds } from 'utils/bulkSelection';
import SearchContacts from './components/SearchContacts';

function mapStateToProps(state) {
    let canCreate =
        state.config?.permission?.crud_permission?.[CONTACTS.permission].create || false;
    const selection = state.entityListSelect?.[CONTACTS.entity];
    const contactsBulkActions = state.config?.permission?.contactsBulkActions;
    const canMergeContacts = state.config?.permission?.mergeContacts;
    const enableBulkOperations = contactsBulkActions || state.config?.permission?.allowSendEmails;

    return {
        canCreate,
        selectionToken: selection && selection.token ? selection.token : null,
        selectedContacts: selection && selection.total ? selection.total : 0,
        selectedIds: getIncludedSelectionIds(selection),
        selectedInfo: selection && selection.info ? selection.info : null,
        enableBulkOperations,
        canMergeContacts,
        contactsBulkActions,
        showMarketingBulkSubscribe: enableBulkOperations && canManageMarketingCampaigns(state),
    };
}

const Menu = memo(
    ({
        enableBulkOperations,
        selectedContacts,
        selectedIds,
        canMergeContacts,
        config,
        contactsBulkActions,
        canCreate,
        onRequestBulkSubscribedConfirm,
        showMarketingBulkSubscribe,
    }) => {
        const bulkOperationsLiterals = useMemo(
            () => ({
                confirmInfoNumEdited: 'confirm_info_num_contact_edited',
                confirmInfoNumDeleted: 'confirm_info_num_contact_deleted',
                entityNameSingular: 'label_contact_singular',
                entityNamePlural: 'label_contacts',
                confirmEditModalTitle: 'title_edit_contacts',
                confirmDeleteModalTitle: 'title_delete_contacts',
                labelTitleMenuTotalSelected: 'label_num_contacts_selected',
                labelTitleMenuTotalSelectedSingular: 'label_num_contacts_selected_singular',
                labelEditTextInfo: 'label_edit_fields_info_contacts',
                labelEditTextInfoSingular: 'label_edit_fields_info_contacts_singular',
                labelDeleteTextInfo: 'label_delete_fields_info',
                labelActionCantUndone: 'label_action_cant_undone',
                labelLoadingConfirmEditModalTitle: 'label_bulk_loading_edit',
                labelLoadingConfirmDeleteModalTitle: 'label_bulk_loading_delete',
                labelWriteXToConfirm: 'label_type_confirmation',
                labelWriteEdit: 'action_edit',
                labelWriteDelete: 'action_delete',
                labelSuccessEditSingular: 'success_edit_contact',
                labelSuccessDeleteSingular: 'success_delete_contact',
                labelSuccessEditPlural: 'success_bulk_edit_contacts',
                labelSuccessDeletePlural: 'success_bulk_delete_contacts',
            }),
            [],
        );

        const extraBulkActions = useMarketingBulkSubscribeExtraActions({
            entity: CONTACTS,
            filterKey: CONTACTS.entity,
            bulkSelectedEntities: selectedContacts,
            selectedIds,
            onRequestBulkSubscribedConfirm,
            enabled: showMarketingBulkSubscribe,
        });

        return (
            <EntityMenu
                entity={CONTACTS}
                withFilters={true}
                canCreate={canCreate}
                canMerge={canMergeContacts}
                canMassiveUpdate={contactsBulkActions}
                canMassiveDelete={contactsBulkActions}
                withBulkOperations={enableBulkOperations}
                bulkOperationsLiterals={bulkOperationsLiterals}
                bulkSelectedEntities={selectedContacts}
                extraBulkActions={extraBulkActions}
                quickFilters={config.quickFilters}
                useQuickView={config.useQuickView}
                searchComponent={<SearchContacts />}
                help={config.help}
            />
        );
    },
);

export default connect(mapStateToProps)(Menu);
